export default {
  contentApiUrl: 'https://content.api.delfi.lt/content/v3/graphql',
};
